<script setup>
// Подготовить заявление на частичное погашение кредита
// ипотека, type=1
import TheCalendar from "@/components/Admin/TheCalendar";
import {useStore} from "vuex";
//import {useRouter} from "vue-router"
// форматирование суммы
import {priceFormat} from '@/use/price-format'
import {useContractInfo} from "@/use/contract-info";
import {useScrollBottom} from "@/use/scroll-bottom";
import {ref, computed, onMounted} from "vue";
import axios from "axios";
//----------------------------------------------------------------------
const store = useStore()
//const router = useRouter();
const summaPayment = ref('')
const summaPaymentDigit = ref(0)
const actionType = ref(0)
const isSummaCorrect = ref(false)
const isLoading = ref(false)
const isSubmitting = ref(false)
const isSubmitComplete = ref(false)
const paymentsRemainingNew = ref(0)
const paymentSummNew = ref(0)
//----------------------------------------------------------------------

onMounted( ()=>{
  store.commit('menuModule/initMenu')
  store.commit('dateModule/initDateAction')
  // const idDataExist = contract.value ? true : false
  const idDataExist = !!contract.value
  // если данные есть в сторе, грузить не будем
  init(idDataExist)
})

// загружаем данные о договоре и платежах
const init = async (idDataExist) => {

  if (!idDataExist){
    await useContractInfo(token.value, user.value.type, user.value.id)
  }

  isLoading.value = true
}

// расчет новых платежей после ДП
const calc = () => {

  paymentFormat()

  isSummaCorrect.value = summaPaymentDigit.value >= 1
  if(isSummaCorrect.value) {

    // месяц ДП
    const mPayment = parseInt(dateAction.value.substr(3, 2));
    const mCurr = new Date().getMonth()+1
    // ДП в следующем месяце
    // const isPaymentNextMonth = (mPayment === mCurr) ? false : true
    const isPaymentNextMonth = (mPayment !== mCurr)
    const balanceNext = parseFloat(store.getters['contractModule/balanceNext'][0])
    const balanceNext2 = parseFloat(store.getters['contractModule/balanceNext'][1])
    const countNoPay = paymentsRemaining.value - 2
    const paymentSumm = parseFloat(contract.value[0]['paymentSumm'])
    const rate = parseFloat(contract.value[0]['rate'])

    // новый платеж
    let a = 0
    if (!isPaymentNextMonth) {
      // ДП в текущем месяце
      a = balanceNext - summaPaymentDigit.value;
    } else {
      // ДП в следующем месяце
      a = balanceNext2 - summaPaymentDigit.value;
    }

    const a1 = rate/1200;
    const a2 = a * a1;
    const a3 = 1 + a1;
    const a4 = Math.pow(a3, -countNoPay);
    const a5 = 1 - a4;
    paymentSummNew.value = Math.round(a2/a5)

    // количество платежей
    paymentsRemainingNew.value = 1 + Math.ceil(Math.log(paymentSumm / (paymentSumm - (a * a1))) / Math.log(a3))
    setTimeout(() => useScrollBottom(), 300);
  }

}

//----------------------------------------------------------------------

const getActionType = (t) => {
  return actionType.value === t
}
const setActionType = (t) => {
  actionType.value = t;
  setTimeout(() => useScrollBottom(), 300);
}

// в инпуте разряды и цифры
const paymentFormat = () => {
  const formatter = new Intl.NumberFormat('ru-RU');
  const RegEx=/\s/g;
  summaPayment.value = summaPayment.value.replace(RegEx,'');
  summaPayment.value = summaPayment.value.replace (/[^0-9'.]/, '');
  summaPaymentDigit.value = Number(summaPayment.value);
  summaPayment.value = formatter.format( Number(summaPayment.value) );
}

//----------------------------------------------------------------------

// отправка заявления
const onSubmit = async () => {

  try {
    isSubmitting.value = true
    const headers = {
      'Authorization': 'Bearer ' + token.value
    }
    const values = {
      'datePayment' : dateAction.value,
      'summaPayment' : summaPayment.value,
      'actionType' : actionType.value
    }

    const payload = {values, ...{'section': user.value.type}, ...{'userId': user.value.id}}

    //console.log(headers)
    //console.log(payload)

    const url = process.env.VUE_APP_API + "create-application.php";

    const {data} = await axios.post(url, payload, {
      headers: headers
    })

    //console.log(data)

    if (data['status'] === 'SUCCESS'){
      isSubmitComplete.value = true
    }

  } catch (e) {
    alert ('INTERNAL_SERVER_ERROR')
  }

}

//----------------------------------------------------------------------

// дата платежа
const dateAction = computed( () => {return store.getters['dateModule/dateAction']})
const token = computed( () => {return store.getters['authModule/token']})
const user = computed( () => {return store.getters['authModule/user']})
const contract = computed( () => {return store.getters['contractModule/contract']})
// осталось платежей
const paymentsRemaining = computed( () => {return store.getters['contractModule/paymentsRemaining']})
//const balanceNext = computed( () => {return store.getters['contractModule/balanceNext']})
</script>

<template>
  <main class="content-wrapper">

    <section class="content-header">
      <div class="container-fluid application-content">
        <div class="row">
          <div class="col">
            <h3>Подготовить заявление на частичное погашение кредита</h3>
            Заявление на ПОЛНОЕ досрочное погашение кредита можно подать только при личном обращении в офис АО «СПБ ЦДЖ»
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div v-if="isLoading" class="container-fluid application-content">

        <div v-if="!isSubmitComplete">

          <div class="number">1</div>
          <div class="v-line"></div>
          <div class="info">
            <h4 class="text-center">Выберите дату</h4>
            Минимальная дата частичного досрочного погашения – дата заявления + 14 дней, кроме выходных и праздничных дней.
          </div>

          <div class="v-line"></div>
          <TheCalendar minDelay="14"></TheCalendar>

          <div class="row" v-if="dateAction">
            <div class="v-line"></div>
            <div class="col-12">
              <div class="card card-outline card-info m-0">
                <div class="card-body">
                  <table
                      class="table"
                  >
                    <tbody>
                    <tr>
                      <td class="border-0 t-col-1">Дата досрочного погашения</td>
                      <td class="border-0 t-col-2">{{ dateAction }}</td>
                    </tr>
                    <tr>
                      <td class="t-col-1">Размер платежа</td>
                      <td class="t-col-2">{{ priceFormat(contract[0].paymentSumm) }}</td>
                    </tr>
                    <tr>
                      <td class="t-col-1">Платежей до погашения</td>
                      <td class="t-col-2">{{ paymentsRemaining }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="col-12 m-0">
              <div class="v-line"></div>
              <div class="number">2</div>
              <div class="v-line"></div>
              <div class="info text-center">
                <h4>Укажите сумму досрочного погашения</h4>
                (не включающую ежемесячный платеж)
              </div>
              <div class="v-line"></div>
              <div class="input-group">
                <input
                    type="text"
                    id="summa-payment"
                    class="input-control"
                    placeholder=""
                    v-model="summaPayment"
                    @input="calc"
                >
              </div>
            </div>
          </div>

          <div class="row" v-if="isSummaCorrect && paymentSummNew > 0">
            <div class="col-12">
              <div class="v-line"></div>
              <div class="number">3</div>
              <div class="v-line"></div>
              <div class="info">
                <h4 class="text-center">Выберите подходящий для Вас вариант</h4>
                Данные предоставлены исходя из предварительного расчета. Новый график платежей будет доступен в Личном кабинете на 5 рабочий день месяца, следующего за месяцем в котором будет исполнено частичное досрочное погашение.
              </div>
            </div>
            <div class="col-lg-6 col-md-12 mt-4">
              <div
                  :class="['card card-outline card-info card-link', getActionType(1) ? 'selected-action' : '']"
                  @click="setActionType(1)"
              >
                <div class="card-body text-center">
                  <v-icon
                      v-if="actionType === 0 || actionType === 2"
                      class="service-icon mb-3"
                      icon="mdi:contactless-payment-circle-outline"
                  ></v-icon>
                  <v-icon
                      v-else
                      class="service-icon--light mb-3"
                      icon="mdi:contactless-payment-circle-outline"
                  ></v-icon>
                  <h5>Сократить размер платежа</h5>
                  <p>Новый платеж составит:</p>
                  <h4 class="mt-4">{{ priceFormat(paymentSummNew) }}</h4>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 mt-4">
              <div
                  :class="['card card-outline card-info card-link', getActionType(2) ? 'selected-action' : '']"
                  @click="setActionType(2)"
              >
                <div class="card-body text-center">
                  <v-icon
                      v-if="actionType < 2"
                      class="service-icon mb-3"
                      icon="mdi:archive-clock-outline"
                  ></v-icon>
                  <v-icon
                      v-else
                      class="service-icon--light mb-3"
                      icon="mdi:archive-clock-outline"
                  ></v-icon>
                  <h5>Сократить срок кредита</h5>
                  <p>Число платежей до погашения составит:</p>
                  <h4 class="mt-4">{{ paymentsRemainingNew }}</h4>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="isSummaCorrect && paymentSummNew <= 0">
            <div class="col-12">
              <h5 class="text-danger text-center mt-3">Указанная сумма досрочного погашения больше допустимой</h5>
            </div>
          </div>

          <div class="row" v-if="actionType && isSummaCorrect && paymentSummNew > 0">
            <div class="col-12">

              <div class="number mt-4">4</div>
              <div class="v-line"></div>

              <button
                class="btn btn-send btn-block fs-15"
                @click="onSubmit()"
                >
                <svg v-if="isSubmitting"
                     xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g>
                  <circle cx="3" cy="12" r="2" fill="#80b5d3"/>
                  <circle cx="21" cy="12" r="2" fill="#80b5d3"/>
                  <circle cx="12" cy="21" r="2" fill="#80b5d3"/>
                  <circle cx="12" cy="3" r="2" fill="#80b5d3"/>
                  <circle cx="5.64" cy="5.64" r="2" fill="#80b5d3"/>
                  <circle cx="18.36" cy="18.36" r="2" fill="#80b5d3"/>
                  <circle cx="5.64" cy="18.36" r="2" fill="#80b5d3"/>
                  <circle cx="18.36" cy="5.64" r="2" fill="#80b5d3"/>
                  <animateTransform attributeName="transform" dur="1.5s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12"/></g>
                </svg>
                <span v-else>Отправить заявление</span>
                </button>
            </div>
          </div>
        </div>

        <div v-else class="card card-outline card-success">
          <div class="card-body text-center">
            <v-icon
                class="success-icon--green mb-3"
                icon="mdi:check-circle-outline"
            ></v-icon>
            <h4 class="pt-2">Заявление успешно отправлено</h4>
          </div>
        </div>

      </div>

      <div v-else class="d-flex justify-content-center application-content">
        <div class="spinner-border text-primary m-4" role="status"></div>
      </div>

    </section>
    <br><br><br>
  </main>
</template>
<style scoped>
.application-content{
  width:800px;
  margin: 0 !important;
}
.input-control{
  font-size: 1.6rem;
  padding: 10px;
  border: 2px solid #80b5d3;
  border-radius: 5px;
  margin:0 auto;
  width:300px;
  text-align: center;
}
.t-col-1{
  width:65%;
}
.t-col-2{
  width:35%;
  font-size: 1.4rem;
  text-align: right;
}
.fs-15{
  font-size: 1.5rem;
}
.selected-action{
  background-color: #80b5d3;
  color:#fff;
}
.card-link{
  cursor: pointer;
  transition: 0.3s;
}
.card-link:hover{
    -webkit-box-shadow: 0 0 15px 4px rgba(34, 60, 80, 0.2);
    -moz-box-shadow: 0 0 15px 4px rgba(34, 60, 80, 0.2);
    box-shadow: 0 0 15px 4px rgba(34, 60, 80, 0.2);
}
.number{
  display: flex;
  align-items:center;
  justify-content:center;
  text-align:center;
  width:50px;
  height:50px;
  border:3px solid #80b5d3;
  border-radius:50%;
  font-size:1.2rem;
  margin: 0 auto;
}
.v-line{
  width:3px;
  height:40px;
  background-color: #80b5d3;
  margin: 0 auto;
}
.service-icon{
  width:50px;
  height:50px;
  color: #80b5d3;
}
.service-icon--light{
  width:50px;
  height:50px;
  color: #fff;
}
.info{
  background-color: #80b5d3;
  color: #fff;
  padding: 25px 20px 20px 20px;
  border-radius: 5px;
}
.card-info.card-outline{
  border-top:3px solid #80b5d3;
}

@media only screen and (max-width : 800px) {
  .t-col-1{
    width:65%;
  }
  .t-col-2{
    width:35%;
    font-size: 0.9rem;
    text-align: right;
  }
  .application-content{
    width:100%;
  }
}

@media only screen and (max-width : 460px) {
  .input-control{
    width:100%
  }
}
</style>